<template>
  <v-card class="mx-3" color="white darken-1" flat>
    <v-card-title class="custom-font-semi-bold custom-text">Correcciones</v-card-title>
    <div class="mx-3">
      <v-select v-model="selected" :items="status" label="Cambiar estado del contrato"
                solo outline flat no-data-text="No hay datos disponibles"></v-select>
      <DatePickerForm v-if="isTermination && ended" v-model="fechaTerminacion" required :error-messages="this.getRequiredErrors('fechaTerminacion')"
      label="Fecha de terminación"></DatePickerForm>
      <v-textarea v-model="text" label="Agregar una observación o comentario (opcional)" outline></v-textarea>
    </div>
    <v-card-actions class="mx-2 pt-0">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="submit" :disabled="saving || !modified">Enviar</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import Constants from '../../../common/constants'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import { validationMixin } from 'vuelidate'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin, createEntityMixin],

  components: {
    DatePickerForm
  },
  props: {
    contractType: String,
    contract: Object
  },

  validations: {
    selected: { required },
    fechaTerminacion: {
      required: requiredIf(function () {
        return this.isTermination && this.ended
      }) }
  },

  data () {
    return {
      saving: false,
      text: '',
      selected: null,
      fechaTerminacion: null
    }
  },

  computed: {
    modified () {
      return this.selected
    },
    isTermination () {
      return this.contract.terminations.length
    },
    ended () {
      return this.selected === Constants.CONTRACT_ENDED
    },
    status () {
      let status = [
        { text: 'Verificado', value: Constants.CONTRACT_VERIFIED },
        { text: 'Rechazado', value: Constants.CONTRACT_REJECTED }
      ]
      if (this.isTermination) {
        status.splice(0, 1, { text: 'Finalizado', value: Constants.CONTRACT_ENDED })
        status.push({ text: 'Verificado/Error-Club', value: Constants.CONTRACT_VERIFIED })
      }
      return status
    }
  },

  methods: {
    getPayload () {
      let payload = {
        contract: this.$route.params.id,
        text: this.text,
        status: this.selected
      }
      if (this.isTermination && this.ended) {
        payload.fechaTerminacion = this.fechaTerminacion
      }
      return payload
    },
    isValidForm () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    submit () {
      if (this.isValidForm()) {
        this.saving = true
        let payload = this.getPayload()
        this.axios
          .post('contract/observation/new', payload)
          .then(() => {
            this.$emit('newObservation')
            this.saving = false
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    }
  }
}
</script>

<style scoped>
.custom-text {
  font-size: 1.2em;
}
</style>
